import { VxSwal } from '@voxie/frontend-components';

export const isLargeTeam = (teamId) => {
    // see app/Team.php
    const largeTeamMap = {
        100404: true, // Victra Wireless
        100818: true, // Edible Arrangements
        100823: true, // D.P. Dough
        100978: true, // PJ's Coffee
        101824: true, // Eargo - Marketing
        102472: true, // Jersey Mike's
        103150: true, // Inspire Brands - Sonic
        103266: true, // Urban Air
        103342: true, // Inspire Brands - Arby's
    };

    return Boolean(largeTeamMap[teamId]);
};

export const isNotActive = () => {
    return Spark.state.currentTeam.status !== 'active';
};

export const displayNotActiveModal = () => {
    const team = Spark.state.currentTeam;

    if (team.status === 'suspended') {
        VxSwal.fire({
            confirmButtonText: 'Dismiss',
            icon: 'error',
            confirmButtonColor: 'danger',
            title: 'This Voxie Account is Suspended',
            html: `Sorry for the inconvenience, we know how important having access to your Voxie account is. Unfortunately, this account has been suspended by our Team${
                team.status_reason ? ', due to '.team.status_reason.split('\n').join('<br />') : '.'
            }
                <br />
                <br />
                Please contact your Account Administrator to rectify the account situation and restore your access immediately.`,
        });
    } else if (team.status === 'closed') {
        VxSwal.fire({
            confirmButtonText: 'Dismiss',
            icon: 'info',
            title: 'This Voxie Account is Closed',
            html: `Please contact your Account Administrator to discuss the creation of a new account.`,
        });
    } else {
        VxSwal.fire({
            confirmButtonText: 'Dismiss',
            title: 'Your Voxie Account is Pending Activation',
            html: `Welcome to Voxie! We're in the process of validating your subscription. Until then, your ability to send texts
                is disabled. Hang tight, you should have access shortly. For any questions please contact your account representative
                or <a href="mailto:support@voxie.com">support@voxie.com</a>.`,
        });
    }
};
